import { render, staticRenderFns } from "./SinglePayment.vue?vue&type=template&id=4a989ee5&"
import script from "./SinglePayment.vue?vue&type=script&lang=js&"
export * from "./SinglePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports